import React, { useRef } from "react";
import { object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TopArrowContainer from "../../atoms/TopArrowContainer";
import ContributorImage from "../../atoms/ContributorImage";
import Button from "../../atoms/Button";

import { staticTexts } from "../../utils/Translate";
import { verifyEmail } from "../../helper/api";

import "./memberNotVerifiedView.m.css";

const MemberNotVerifiedView = ({ member, logout, navigateToPage, closeView, publisherAttributes }) => {
  const viewRef = useRef(null);

  const verifyEmailAccount = () => {
    verifyEmail(member.email).then(() => navigateToPage(`/verify-email?id=${member.id}`));
  };

  return (
    <div styleName="top-arrow-container-wrapper" ref={viewRef}>
      <TopArrowContainer closeView={closeView}>
        <div styleName="wrapper">
          <div styleName="profile">
            <div styleName="image-name-wrapper">
              <ContributorImage authorObj={member} />
              <span styleName="name">{member.name}</span>
            </div>
          </div>

          <div styleName="not-verified">
            <span>{staticTexts(publisherAttributes.lang).notVerifiedText}</span>
            <a styleName="email-verify" onClick={verifyEmailAccount}>
              {staticTexts(publisherAttributes.lang).clickToVerifyText}
            </a>
          </div>

          <Button content={staticTexts(publisherAttributes.lang).logOut} buttonType="type4" onClick={logout} />
        </div>
      </TopArrowContainer>
    </div>
  );
};

MemberNotVerifiedView.propTypes = {
  member: object.isRequired,
  closeView: func,
  navigateToPage: func,
  logout: func,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps)(MemberNotVerifiedView);
